var Option = function Option() {
  return null;
};

Option.isSelectOption = true;
Option.displayName = 'ASelectOption';
export default Option;